/**
 * @file Validates that a string is a decimal amount with at most two fraction digits.
 */
const DECIMAL_REGEX = /^\d+(\.\d{1,2})?$/;

/**
 * Reports whether a string is a valid decimal amount with at most two fraction digits.
 */
const validateDecimalValue = (value: string): boolean => {
  const isValid = DECIMAL_REGEX.test(value);

  return isValid;
};

export default validateDecimalValue;
